import React, { useEffect, useState } from 'react';
import { Box, Checkbox, makeStyles, MenuItem, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { ColumnFilter } from './ColumnFilter';
const columns = [
    {
        id: 'eventCode',
        label: 'Код события',
        minWidth: 280,
        optionsKey: 'eventCodes',
        containsKey: 'eventCodeContains',
    },
    {
        id: 'eventLinkDescription',
        label: 'Примечание',
        minWidth: 200,
        optionsKey: 'eventLinkDescriptions',
        containsKey: 'eventLinkDescriptionContains',
    },
    {
        id: 'chainTypeCode',
        label: 'Тип интеграц. цепочки',
        minWidth: 200,
        optionsKey: 'chainTypeCodes',
        containsKey: 'chainTypeCodeContains',
        exactKey: 'chainTypeCode',
    },
    {
        id: 'chainTypeDescription',
        label: 'Описание интеграц. цепочки',
        minWidth: 200,
        optionsKey: 'chainTypeDescriptions',
        containsKey: 'chainTypeDescriptionContains',
    },
];
const ENABLED_ALL = 'all';
export const rowsPerPageSetting = [10, 30, 50, 100, 1000];
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },
    container: {
        flexGrow: 1,
    },
    tableRow: {
        cursor: 'pointer',
    },
    pageInput: {
        width: '150px',
    },
    headerCell: {
        verticalAlign: 'top',
    },
    headerLabel: {
        marginBottom: '8px',
    },
}));
export const EventChainLinksTable = ({ rows, onClickRow, filterOptions, filters, onChangeFilters, onToggleEnabled, pendingToggle, totalCount, totalPages, pageSize, currentPage, onChangePage, onChangeRowsPerPage, }) => {
    const styles = useStyles();
    // Черновик номера страницы - применяется по Enter или потере фокуса, а не на каждый символ.
    const [pageDraft, setPageDraft] = useState(String(currentPage));
    useEffect(() => {
        setPageDraft(String(currentPage));
    }, [currentPage]);
    const applyPageDraft = () => {
        const parsed = Number(pageDraft);
        if (!Number.isInteger(parsed)) {
            setPageDraft(String(currentPage));
            return;
        }
        const nextPage = Math.min(Math.max(parsed, 1), Math.max(totalPages, 1));
        setPageDraft(String(nextPage));
        if (nextPage !== currentPage) {
            onChangePage(nextPage);
        }
    };
    const handlePageKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            applyPageDraft();
        }
    };
    const handleChangePage = (_, newPage) => {
        onChangePage(newPage + 1);
    };
    const handleChangeRowsPerPage = (event) => {
        onChangeRowsPerPage(Number(event.target.value));
    };
    // Поле фильтра показывает то значение, которое сейчас применено: точное или "содержит".
    const getColumnFilterValue = (column) => (column.exactKey && filters[column.exactKey]) || filters[column.containsKey] || '';
    const handleApplyColumnFilter = (column, value, isOption) => {
        const patch = { [column.containsKey]: undefined };
        if (column.exactKey) {
            patch[column.exactKey] = undefined;
        }
        if (value) {
            patch[isOption && column.exactKey ? column.exactKey : column.containsKey] = value;
        }
        onChangeFilters(patch);
    };
    const handleChangeEnabledFilter = (event) => {
        const { value } = event.target;
        onChangeFilters({ enabled: value === ENABLED_ALL ? undefined : value === 'true' });
    };
    return (React.createElement(Paper, { className: styles.root },
        React.createElement(TableContainer, { className: styles.container },
            React.createElement(Table, { stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { className: styles.headerCell, style: { minWidth: 110 } },
                            React.createElement("div", { className: styles.headerLabel }, "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E"),
                            React.createElement(TextField, { select: true, fullWidth: true, size: "small", variant: "outlined", value: filters.enabled === undefined ? ENABLED_ALL : String(filters.enabled), onChange: handleChangeEnabledFilter },
                                React.createElement(MenuItem, { value: ENABLED_ALL }, "\u0412\u0441\u0435"),
                                React.createElement(MenuItem, { value: "true" }, "\u0414\u0430"),
                                React.createElement(MenuItem, { value: "false" }, "\u041D\u0435\u0442"))),
                        columns.map((column) => (React.createElement(TableCell, { key: column.id, className: styles.headerCell, style: { minWidth: column.minWidth } },
                            React.createElement("div", { className: styles.headerLabel }, column.label),
                            React.createElement(ColumnFilter, { options: filterOptions?.[column.optionsKey] ?? [], value: getColumnFilterValue(column), onApply: (value, isOption) => handleApplyColumnFilter(column, value, isOption) })))))),
                React.createElement(TableBody, null, rows.map((row) => {
                    const pendingEnabled = pendingToggle?.guid === row.guid ? pendingToggle.enabled : undefined;
                    const isPending = pendingEnabled !== undefined;
                    return (React.createElement(TableRow, { className: styles.tableRow, key: row.guid, hover: true, onClick: () => onClickRow(row) },
                        React.createElement(TableCell, { padding: "checkbox", onClick: (event) => event.stopPropagation() },
                            React.createElement(Checkbox, { color: "primary", checked: pendingEnabled ?? row.enabled, disabled: isPending, onChange: (event) => onToggleEnabled(row, event.target.checked) })),
                        columns.map((column) => (React.createElement(TableCell, { key: column.id }, row[column.id])))));
                })))),
        totalCount > 0 && (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "flex-end", pl: 2 },
            React.createElement(TextField, { className: styles.pageInput, size: "small", variant: "outlined", type: "number", label: `Страница из ${totalPages}`, inputProps: { min: 1, max: totalPages }, value: pageDraft, onChange: (event) => setPageDraft(event.target.value), onBlur: applyPageDraft, onKeyDown: handlePageKeyDown }),
            React.createElement(TablePagination, { labelRowsPerPage: 'Cтрок на странице', rowsPerPageOptions: rowsPerPageSetting, component: "div", count: totalCount, rowsPerPage: pageSize, page: currentPage - 1, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage })))));
};
